import { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ConfirmDialog, Input } from '@bliks-io/ui';

interface DeleteTenantConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting?: boolean;
  tenantName: string;
}

export function DeleteTenantConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isDeleting = false,
  tenantName
}: DeleteTenantConfirmDialogProps) {
  const { t } = useTranslation();
  const [confirmInput, setConfirmInput] = useState('');

  const isConfirmed = confirmInput === tenantName;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('tenantAdmin.deleteTitle')}
      description={t('tenantAdmin.deleteDescription')}
      confirmLabel={t('common.delete')}
      variant="danger"
      onConfirm={onConfirm}
      isPending={isDeleting}
      isConfirmDisabled={!isConfirmed}
    >
      <p className="text-sm text-muted-foreground mb-3">
        <Trans
          i18nKey="tenantAdmin.deleteConfirmInstruction"
          components={{
            strong: <strong className="text-foreground font-semibold">{tenantName}</strong>
          }}
        />
      </p>
      <Input
        value={confirmInput}
        onChange={(e) => setConfirmInput(e.target.value)}
        placeholder={t('tenantAdmin.deleteConfirmPlaceholder')}
        autoComplete="off"
      />
    </ConfirmDialog>
  );
}
